import {Directive, HostListener} from "@angular/core";
    
@Directive({
    selector: "[wfdss-click-stop-propagation]",
    standalone: false
})
export class DClickStopPropagation
{
    @HostListener("click", ["$event"])
    public onClick(event: any): void
    {
        // window.alert("stoppaproppa")
        event.stopPropagation();
    }
}